'use client';

import { I18nProvider } from '@/context/I18nContext';
import type { Locale } from '@/lib/i18n';
import enTranslations from '@/messages/en.json';
import trTranslations from '@/messages/tr.json';
import deTranslations from '@/messages/de.json';

export function I18nProviderWrapper({
  children,
  initialLocale,
}: {
  children: React.ReactNode;
  initialLocale: Locale;
}) {
  const translations = {
    en: enTranslations,
    tr: trTranslations,
    de: deTranslations,
  };

  return (
    <I18nProvider translations={translations} initialLocale={initialLocale}>
      {children}
    </I18nProvider>
  );
}
